import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context/UserContext';
import { TitleText } from '../../Teams/style/RegisteredTeamsStyle';
import { trackEventMatomo } from '../../../helpers/matomo';
import { Card, TextField } from '@mui/material';
import HeaderModal from '../../HeaderModal/HeaderModal';
import FooterModal from '../../FooterModal/FooterModal';

export default function NewModal({
  setModalOpen,
  modalOpen,
  create,
  nameCreate,
  isDisabled
}
  : {
    setModalOpen: Function,
    modalOpen: boolean,
    create: Function,
    nameCreate: string
    isDisabled: boolean
  }) {
  const { t } = useTranslation('translation');
  const { hierarchyLabel } = useContext(UserContext);
  const [name, setName] = useState('');

  const close = () => {
    setModalOpen(false);
    setName('');
  };

  const submit = () => {
    trackEventMatomo('Modal criação de conjunto/unidade', 'click', 'button', 'salvar');
    create(name);
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  return (
    <Card>
      <TitleText>
        <div className={`modal ${modalOpen ? "modal is-active" : "modal"}`}>
          <div className="modal-background" onKeyDown={(e) => escape(e)} onClick={close} />
          <div className="modal-card" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
            <HeaderModal headerTitle={`${t('Services.ServiceModal.add')} ${nameCreate === 'conjunto' ? hierarchyLabel.conjunto : hierarchyLabel.unidade}`} close={close} />
            <div className="modal-card-body">
              <TextField
                onClick={() => trackEventMatomo('Modal criação de conjunto/unidade', 'click', 'textfield', 'editar valor')}
                style={{ marginBottom: '20px' }}
                fullWidth
                label={t('name')}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <FooterModal disabled={name === '' || isDisabled} submit={submit}  label={`${t('save')}`} />
          </div>
        </div>
      </TitleText>
    </Card>
  );
}
